import React, { PureComponent } from 'react'
import styled from 'styled-components'

import { PURPLE, WHITE } from 'src/styles/colors.js'

const SiteFooterContainer = styled.footer`
  padding: 40px;
  background: ${WHITE};
  color: ${PURPLE};
  font-size: 14px;
  text-align: center;
`

/**
 * Site Footer
 */
const SiteFooter = () => (
  <SiteFooterContainer>&copy; Förbundet Tillsammansskapet</SiteFooterContainer>
)

export default SiteFooter
